/**
 * @generated SignedSource<<85ff5d9cf1c9d2798439ecc20e7cf22f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InvoiceState = "DRAFT" | "INVOICE_NUMBER_PENDING" | "OPEN" | "PAID" | "REFUNDED" | "REVERSED" | "UNCOLLECTIBLE" | "VOID" | "%future added value";
export type InvoiceType = "REGULAR" | "REVERSE" | "%future added value";
export type AnalysisOpenItemsViewQuery$variables = {
  cutOffDate: any;
  invoiceYear?: number | null | undefined;
};
export type AnalysisOpenItemsViewQuery$data = {
  readonly openItems: {
    readonly cutOffDate: any;
    readonly invoices: ReadonlyArray<{
      readonly address: {
        readonly businessName: string;
      };
      readonly dueDate: any;
      readonly id: string;
      readonly invoiceDate: any;
      readonly invoiceNumber: string | null | undefined;
      readonly settledAt: any | null | undefined;
      readonly state: InvoiceState;
      readonly totalGrossAmount: number;
      readonly totalNetAmount: number;
      readonly type: InvoiceType;
    }>;
    readonly totalGrossAmount: number;
    readonly totalNetAmount: number;
    readonly writtenOffGrossAmount: number;
  };
};
export type AnalysisOpenItemsViewQuery = {
  response: AnalysisOpenItemsViewQuery$data;
  variables: AnalysisOpenItemsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cutOffDate"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "invoiceYear"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalNetAmount",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalGrossAmount",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "cutOffDate",
        "variableName": "cutOffDate"
      },
      {
        "kind": "Variable",
        "name": "invoiceYear",
        "variableName": "invoiceYear"
      }
    ],
    "concreteType": "OpenItemsReport",
    "kind": "LinkedField",
    "name": "openItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cutOffDate",
        "storageKey": null
      },
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "writtenOffGrossAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Invoice",
        "kind": "LinkedField",
        "name": "invoices",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "settledAt",
            "storageKey": null
          },
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessAddress",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "businessName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisOpenItemsViewQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnalysisOpenItemsViewQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "1afd2712be2f70e39d670b34fb165900",
    "id": null,
    "metadata": {},
    "name": "AnalysisOpenItemsViewQuery",
    "operationKind": "query",
    "text": "query AnalysisOpenItemsViewQuery(\n  $cutOffDate: DateTime!\n  $invoiceYear: Int\n) {\n  openItems(cutOffDate: $cutOffDate, invoiceYear: $invoiceYear) {\n    cutOffDate\n    totalNetAmount\n    totalGrossAmount\n    writtenOffGrossAmount\n    invoices {\n      id\n      type\n      invoiceNumber\n      state\n      invoiceDate\n      dueDate\n      settledAt\n      totalNetAmount\n      totalGrossAmount\n      address {\n        businessName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0f097b39f6518a02edf7dbd9b373a8bc";

export default node;
